var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCardPayment = function SvgCardPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_2451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 38,
    width: 61,
    height: 35,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 44.7874V72.5136C19 73.9554 19.5915 75.3971 20.6266 76.4322C21.6617 77.4674 23.1035 78.0588 24.5452 78.0588H76.3009C77.7427 78.0588 79.1844 77.4674 80.2195 76.4322C81.2547 75.3971 81.8462 73.9554 81.8462 72.5136V44.7874H19ZM28.2421 72.5136C26.2088 72.5136 24.5452 70.85 24.5452 68.8168C24.5452 66.7835 26.2088 65.1199 28.2421 65.1199C30.2753 65.1199 31.9389 66.7835 31.9389 68.8168C31.9389 70.85 30.2753 72.5136 28.2421 72.5136ZM39.3326 72.5136C37.2993 72.5136 35.6357 70.85 35.6357 68.8168C35.6357 66.7835 37.2993 65.1199 39.3326 65.1199C41.3658 65.1199 43.0294 66.7835 43.0294 68.8168C43.0294 70.85 41.3658 72.5136 39.3326 72.5136Z",
    fill: "#E9DBBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8462 35.5452V41.0905H19V35.5452C19 34.1035 19.5915 32.6617 20.6266 31.6266C21.6617 30.5915 23.1035 30 24.5452 30H76.3009C77.7427 30 79.1844 30.5915 80.2195 31.6266C81.2547 32.6617 81.8462 34.1035 81.8462 35.5452Z",
    fill: "#E9DBBC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_2451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCardPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/card-payment.847c813c.svg";
export { ForwardRef as ReactComponent };